import {
    ServiceNursingCareDiagnosisGroupUpdateInput,
} from '@libs/types/src/services/input-type/services/service-nursing-care-diagnosis-groups.update-input';
import {
    ServiceNursingCareDiagnosisGroupCreateInput,
} from '@libs/types/src/services/input-type/services/service-nursing-care-diagnosis-groups.create-input';
import { isInvalid } from '../../../../../shared/helpers/validate';
import {
    ServiceNursingCareDiagnosisGroupObject,
} from '@libs/types/src/services/object-type/service/service-nursing-care-diagnosis-group.object';
import { ConfirmBuilder } from '../../../../../shared/service/confirm.builder';
import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceNursingCareDiagnosisGroupDialogStore } from './service-nursing-care-diagnosis-group-dialog.store';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { FormBuilder, Validators } from '@angular/forms';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';
import { DeleteButtonComponent } from '../../../../../../components/kit/button/delete-button.component';

@Component({
    selector: 'app-service-nursing-care-diagnosis-group-dialog',
    templateUrl: 'service-nursing-care-diagnosis-group-dialog.component.html',
    providers: [ServiceNursingCareDiagnosisGroupDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        TextInputComponent,
        CheckInputComponent,
        ActionButtonsComponent,
        DeleteButtonComponent,
    ],
})
export class ServiceNursingCareDiagnosisGroupDialogComponent extends SubscriptionComponent {

    protected readonly store = inject(ServiceNursingCareDiagnosisGroupDialogStore);
    private readonly fb = inject(FormBuilder);
    private readonly confirm = inject(ConfirmBuilder);

    @Input() group: ServiceNursingCareDiagnosisGroupObject | null = null;

    protected title = 'service.nursingCareDiagnosisGroup.add.title';
    protected visible = false;

    protected form = this.fb.group({
        name: this.fb.control<string>('', Validators.required),
        active: this.fb.control<boolean>(true, Validators.required),
    });

    constructor() {
        super();
        this.store.registerSuccessMessage('createServiceNursingCareDiagnosisGroup', 'common.created');
        this.store.registerSuccessMessage('updateServiceNursingCareDiagnosisGroup', 'common.updated');
        this.store.registerSuccessMessage('deleteServiceNursingCareDiagnosisGroup', 'common.deleted');
        this.store.doOnActions(
            () => this.show(false),
            'deleteServiceNursingCareDiagnosisGroup',
        );
    }

    public show(visible: boolean = true, group: ServiceNursingCareDiagnosisGroupObject | null = null): void {
        this.visible = visible;
        this.group = group;
        if (group) {
            this.title = 'service.nursingCareDiagnosisGroup.edit.title';
            this.form.patchValue({
                ...group,
            });
        } else {
            this.form.reset({
                name: '',
                active: true,
            });
        }
    }

    protected async submit(): Promise<void> {
        if (isInvalid(this.form)) return;
        const serviceId = Number(this.store.routeParam.serviceId.value);

        if (!this.group) {
            this.store.api.createServiceNursingCareDiagnosisGroup({
                serviceId,
                ...this.form.value,
            } as ServiceNursingCareDiagnosisGroupCreateInput);
        } else {
            this.store.api.updateServiceNursingCareDiagnosisGroup({
                serviceId,
                id: this.group.id,
                ...this.form.value,
            } as ServiceNursingCareDiagnosisGroupUpdateInput);
        }

        this.show(false);
    }

    protected delete(): void {
        if (this.group) {
            this.confirm.confirm(
                'common.delete',
                null,
                () => this.store.api.deleteServiceNursingCareDiagnosisGroup({ id: this.group!.id }),
                null,
                'pi-trash',
            );
        }
    }
}
